export default {
  setTechExcelFiles(state, payload) {
    state.techExcelFiles = payload
  },
  setTechInfrastructure(state, objects) {
    state.techInfrastructure = objects
  },
  setTechSelectedInfrastructure(state, data) {
    state.techSelectedInfrastructure = data
  },
  updateTechMapData(state, data) {
    state.techMapData = Object.assign(state.techMapData, data)
  },
  setTechMapData(state, data) {
    state.techMapData = data
  },
  setTechLoadingData(state, action) {
    state.techLoadingData = action ? state.techLoadingData + 1 : state.techLoadingData - 1
  },
  setTechMapParams(state, data) {
    state.techMapParams = data
  },
}



// WEBPACK FOOTER //
// ./src/store/technologies/mutations.js